/**
 * Deployed HTTPS callable names for beer operations (matches Firebase registration).
 */

export const CALLABLE_BEER_ADD_BEER = 'callableBeerAddBeer-addBeer';
export const CALLABLE_BEER_STYLE_CREATE =
  'callableBeerStyleCreateBeerStyle-createBeerStyle';
export const CALLABLE_BEER_LIST_BREWERY_BEER_SOURCES =
  'callableBeerListBreweryBeerSources-listBreweryBeerSources';
export const CALLABLE_BEER_UPSERT_BREWERY_BEER_SOURCE =
  'callableBeerUpsertBreweryBeerSource-upsertBreweryBeerSource';
export const CALLABLE_BEER_SET_TRUSTED_BREWERY_BEER_SOURCE =
  'callableBeerSetTrustedBeerSource-setTrustedBeerSource';
export const CALLABLE_BEER_UPDATE_BREWERY_BEER_SOURCE_STATUS =
  'callableBeerUpdateBeerSourceStatus-updateBeerSourceStatus';
export const CALLABLE_BEER_LIST_BEER_INGESTION_RUNS =
  'callableBeerListBeerIngestionRuns-listBeerIngestionRuns';
export const CALLABLE_BEER_LIST_BEER_INGESTION =
  'callableBeerListBeerIngestion-listBeerIngestion';
export const CALLABLE_BEER_CLASSIFY_BEER_INGESTION_BREWERY =
  'callableBeerClassifyBeerIngestion-classifyBeerIngestion';
export const CALLABLE_BEER_EXCLUDE_BEER_INGESTION_BREWERY =
  'callableBeerExcludeBeerIngestion-excludeBeerIngestion';
export const   CALLABLE_BEER_RUN_BEER_SOURCE_MONITOR =
  'callableBeerRunBeerSourceMonitor-runBeerSourceMonitor';
export const CALLABLE_BEER_RECREATE_BEER_SOURCE_MONITOR =
  'callableBeerRecreateBeerSourceMonitor-recreateBeerSourceMonitor';
export const CALLABLE_BEER_ENABLE_SRC_MONITORING =
  'callableBeerEnableSrcMonitoring-enableSrcMonitoring';

export const SOURCE_CATEGORIES = ['official', 'aggregator', 'other'];

export const SOURCE_STRUCTURES = [
  'single-page-catalog',
  'summary-list',
  'pdf-menu',
  'image-menu',
  'embed',
  'unsupported',
  'unknown',
];

export const MONITORING_STATUSES = ['active', 'paused', 'retired'];

export const NO_SUITABLE_SOURCE_REASONS = [
  'image_menu',
  'no_official_page',
  'abandoned',
  'mixed_or_guest_only',
  'pdf_unreadable',
  'other',
];

export const BEER_INGESTION_DERIVED_STATUSES = [
  'trusted',
  'needs_source',
  'no_suitable_source',
  'excluded',
];

export const BEER_INGESTION_STATUS_FILTER_ALL = 'all';
export const BEER_INGESTION_DEFAULT_STATE = 'NH';
export const BEER_INGESTION_TRUST_TARGET_PERCENT = 80;
export const FRESHNESS_TARGET_PERCENT = 90;
export const REVIEWABLE_TARGET_PERCENT = 90;
export const PILOT_BUDGET_CREDITS = 5000;
export const INCREMENT_1B_NO_SOURCE_REASONS = ['image_menu', 'pdf_unreadable'];

/** Registry scrape rows. Missing/null sourceType is the legacy marker for the same kind. */
export const INGESTION_PIPE_SOURCE_TYPE = 'ingestion_pipe';

/** Known add/import provenance values stored on legacy breweryBeerSources rows. */
export const BEER_SOURCE_PROVENANCE_TYPES = [
  'mobile_user',
  'engage_user',
  'brewhouse_user',
  'sheet_import',
  'dupe_override',
];

export const INGESTION_RUN_STATUSES = [
  'pending',
  'running',
  'success',
  'partial',
  'failure',
];

export const INGESTION_TRIGGERS = [
  'manual',
  'scheduled',
  'source_change',
  'retry',
  'manual_check',
];

export const INGESTION_RUN_KINDS = ['import', 'extraction'];

export const CALLABLE_BEER_GET_BEER_INGESTION_RUN =
  'callableBeerGetBeerIngestionRun-getBeerIngestionRun';
export const CALLABLE_BEER_RETRY_INGESTION_RUN =
  'callableBeerRetryIngestionRun-retryIngestionRun';
export const CALLABLE_BEER_LIST_INGESTION_REVIEWS =
  'callableBeerListIngestionReviews-listIngestionReviews';
export const CALLABLE_BEER_DECIDE_INGESTION_CANDIDATE =
  'callableBeerDecideIngestionCandidate-decideIngestionCandidate';
export const CALLABLE_BEER_BULK_APPROVE_INGESTION =
  'callableBeerBulkApproveIngestion-bulkApproveIngestion';
export const CALLABLE_BEER_BULK_REJECT_INGESTION =
  'callableBeerBulkRejectIngestion-bulkRejectIngestion';
export const CALLABLE_BEER_COMPLETE_INGESTION_REVIEW =
  'callableBeerCompleteIngestionReview-completeIngestionReview';
export const CALLABLE_BEER_APPLY_INGESTION_REVIEW =
  'callableBeerApplyIngestionReview-applyIngestionReview';

/** ITT-970: re-run shadow profile resolve + live compare for one beer. */
export const CALLABLE_BEER_RECOMPARE_BEER_PROFILE =
  'callableBeerRecompareBeerProfile-recompareBeerProfile';

export const CALLABLE_BEER_LIST_INGESTION_FAILURES =
  'callableBeerListIngestionFailures-listIngestionFailures';
export const CALLABLE_BEER_UPDATE_INGESTION_FAILURE_DISPOSITION =
  'callableBeerUpdateFailureDisposition-updateFailureDisposition';
export const CALLABLE_BEER_RETRY_INGESTION_FAILURE =
  'callableBeerRetryIngestionFailure-retryIngestionFailure';

/** ITT-972: Increment 1a profile processing failure queue (globalAdmin). */
export const CALLABLE_BEER_LIST_PROFILE_FAILURES =
  'callableBeerListProfileFailures-listProfileFailures';
export const CALLABLE_BEER_RETRY_PROFILE_FAILURE =
  'callableBeerRetryProfileFailure-retryProfileFailure';
export const CALLABLE_BEER_UPDATE_PROFILE_FAILURE_DISP =
  'callableBeerUpdateProfileFailureDisp-updateProfileFailureDisp';

/** Matches `listBeerIngestionRuns` callable max limit. */
export const BEER_INGESTION_RUN_LIST_LIMIT = 50;
